import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import CartContext from '../../context/CartContext';
import { useNavigate } from "react-router-dom";
import './CriarFatura.css';

const CriarFatura = () => {
  const { cart, clearCart } = useContext(CartContext); // ✅ usar clearCart
  const navigate = useNavigate();

  const [formulario, setFormulario] = useState({
    cliente_nome: '',
    cliente_email: '',       
    cliente_endereco: '',
    cliente_nif: '',
  });

  const [faturaId, setFaturaId] = useState(null);
  const [numeroFatura, setNumeroFatura] = useState(null);
  const [erro, setErro] = useState(null);
  const [mensagem, setMensagem] = useState(null);
  const [loading, setLoading] = useState(false); 
  const [loadingCriar, setLoadingCriar] = useState(false); 

  // 🔥 Scroll no carregamento inicial
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" }); 
  }, []);

  // 🔥 Scroll quando fatura é criada e aparece a mensagem de sucesso
  useEffect(() => {
    if (faturaId) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [faturaId]);

  const aplicar25Porcento = (preco) => {
    return Number(preco) + (Number(preco) * 0.25);
  };

  const produtos = cart.map((item, i) => {
    const precoBase = Number(item.preco_com_iva || 0);
    const precoCom25 = aplicar25Porcento(precoBase);

    return {
      codigo: item.codigo || `1.${i + 1}`,
      descricao: item.descricao,
      quantidade: item.quantity || 1,
      unidade: item.unidade || 'un',
      preco_unitario: parseFloat(precoCom25.toFixed(2)), 
      desconto: 0,
    };
  });

  const calcularTotal = () => {
    return produtos.reduce((total, item) => {
      return total + item.preco_unitario * item.quantidade;
    }, 0);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormulario({ ...formulario, [name]: value });
  };

  const enviarFatura = async () => {
    const valor_total = calcularTotal();
    const payload = {
      cliente_nome: formulario.cliente_nome,
      cliente_email: formulario.cliente_email,  
      cliente_endereco: formulario.cliente_endereco,
      cliente_nif: formulario.cliente_nif,
      produtos: produtos,
      valor_total: valor_total.toFixed(2),
    };

    setLoadingCriar(true); 
    try {
      const response = await axios.post('https://api.nwayami.com/api/api/faturas/', payload);
      setFaturaId(response.data.id);
      setNumeroFatura(response.data.numero);
      setErro(null);

      clearCart(); // ✅ Zera o carrinho

      setFormulario({  // ✅ Limpa formulário
        cliente_nome: '',
        cliente_email: '',
        cliente_endereco: '',
        cliente_nif: '',
      });

    } catch (err) {
      setErro('Erro ao criar Proforma.');
      console.error(err);
    } finally {
      setLoadingCriar(false); 
    }
  };

  const baixarProforma = async () => {
    if (!faturaId) return;

    setLoading(true); 
    try {
      const response = await axios.get(
        `https://api.nwayami.com/api/api/faturas/${faturaId}/gerar-proforma/`,
        { responseType: 'blob' }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Proforma_${numeroFatura || faturaId}.pdf`);
      document.body.appendChild(link);
      link.click();

      // ✅ Mostra mensagem de sucesso e redireciona
      setMensagem("✅ Proforma baixada com sucesso! Redirecionando...");
      clearCart(); // ✅ também limpa aqui

      setTimeout(() => {
        navigate("/");
      }, 1500);

    } catch (err) {
      console.error("Erro ao baixar proforma:", err);
      setErro("Erro ao baixar proforma.");
    } finally {
      setLoading(false); 
    }
  };

  return (
    <div className="criar-fatura-container">
      {!faturaId ? (
        <>
          <h3>Criar Proforma</h3>

          <label>Nome do Cliente:</label>
          <input type="text" name="cliente_nome" value={formulario.cliente_nome} onChange={handleChange} />

          <label>Email:</label>
          <input type="email" name="cliente_email" value={formulario.cliente_email} onChange={handleChange} />

          <label>Endereço:</label>
          <input type="text" name="cliente_endereco" value={formulario.cliente_endereco} onChange={handleChange} />

          <label>NIF:</label>
          <input type="text" name="cliente_nif" value={formulario.cliente_nif} onChange={handleChange} />

          <h3>Produtos do Carrinho</h3>
          {produtos.length === 0 ? (
            <p>Nenhum produto no carrinho.</p>
          ) : (
            <ul className="produtos-lista">
              {produtos.map((produto, index) => (
                <li key={index}>
                  {produto.descricao} — {produto.quantidade} x {produto.preco_unitario.toFixed(2)} AOA
                </li>
              ))}
            </ul>
          )}

          <p><strong>Total:</strong> {calcularTotal().toFixed(2)} AOA</p>

          <br />

          <button className="btn btn-criar" onClick={enviarFatura} disabled={produtos.length === 0 || loadingCriar}>
            {loadingCriar ? (
              <>
                <span className="spinner"></span> Criando...
              </>
            ) : (
              "Criar Proforma"
            )}
          </button>
        </>
      ) : (
        <div className="success-container">
          <p className="success-msg">✅ Proforma criada com sucesso!</p>
          <button className="btn btn-baixar" onClick={baixarProforma} disabled={loading}>
            {loading ? (
              <>
                <span className="spinner"></span> Baixando...
              </>
            ) : (
              "Baixar Proforma"
            )}
          </button>
        </div>
      )}

      {mensagem && <p className="success-msg">{mensagem}</p>}
      {erro && <p className="error-msg">{erro}</p>}
    </div>
  );
};

export default CriarFatura;
